import { useContext, useEffect, useState } from 'react';
import DigibookContext from '../_contexts/DigibookContext';
import { MaterialDataContext } from '../_contexts/MaterialDataProvider';
import { Digibook } from '../api/digibookApi';

export default function useDigibook() {
  const { digibook } = useContext(DigibookContext);
  const { selectedNodeIds } = useContext(MaterialDataContext);

  const selectedNodeId = selectedNodeIds[selectedNodeIds.length - 1];

  const [pageRange, setPageRange] = useState<Digibook['pageRanges'][0]>();

  useEffect(() => {
    if (!digibook) return;

    const range = digibook.pageRanges.find(pageRange => pageRange.nodeId === selectedNodeId);

    setPageRange(range);
  }, [digibook, selectedNodeId]);

  return {
    digibook,
    pageRange,
    pageNumber: pageRange?.from ?? 0,
  };
}
